import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV03 from '../actions/actionTypesNV03';
import { GetNV03VALFItemListSaga } from './NV03.saga';


export function* watchGetNV03ItemListSaga() {
  yield takeLatest(actionTypesNV03.NV03_VALF_LIST_GET, GetNV03VALFItemListSaga);
}

